var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.is_mobile_mode)?_c('section',[_c('h2',[_vm._v("請點擊右上角功能選單")]),_c('h3',[_vm._v("進入相應功能畫面")])]):_c('section',[_c('h2',[_vm._v("請點擊左方功能選單")]),_c('h3',[_vm._v("進入相應功能畫面")])])])}
var staticRenderFns = []

export { render, staticRenderFns }